import Theme from '@/shared/app/model/theme/Theme';

const theme: Theme = {
  background1: '#000',
  background2: 'lightgray',
  color1: '#fff',
  color2: '#000',
  color3: '#fff',
  weight1: 'normal',
  font1: 'Roboto',
};

export default theme;
